/**
 * Ops-facing Chinese labels for phone JSON keys and sections.
 * Schema remains source of shape; this map is UX only.
 */

import { DEVICE_APP_KEYS } from "../../case-spec";

const KEY_LABELS: Record<string, string> = {
  id: "案件 ID",
  locale: "语言",
  timezone: "时区",
  phone_runtime_version: "手机运行时版本",
  meta: "元信息",
  title: "标题",
  description: "描述",
  cover: "封面",
  tags: "标签",
  game: "游戏",
  cast: "角色",
  protagonist: "主角（机主）",
  guide: "向导",
  player: "玩家角色",
  guideSteps: "引导步骤",
  puzzleSteps: "谜题",
  closing: "收尾",
  kind: "类型",
  messages: "消息",
  messages_recently_deleted: "最近删除短信",
  body: "正文",
  subtitle: "副标题",
  choices: "选项",
  label: "标签",
  reply: "回复",
  after: "后续气泡",
  is_free: "是否为付费关卡",
  question: "问题",
  correct_answer: "正确答案",
  error_reply: "答错回复",
  hints: "提示",
  level_1: "一级 Hint",
  level_2: "二级 Hint",
  statement: "结案陈述",
  truth_review: "真相复盘",
  canon: "设定",
  people: "人物",
  name: "姓名",
  contact: "联系方式",
  phone: "电话",
  email: "邮箱",
  address: "地址",
  is_protagonist: "是主角",
  is_guide: "是向导",
  is_player: "是玩家角色",
  avatar_url: "头像",
  icon: "图标",
  relationships: "关系",
  from: "从",
  to: "到",
  world: "世界",
  locations: "地点",
  lat: "纬度",
  lng: "经度",
  weather: "天气",
  day: "日期",
  city: "城市",
  temp_high_c: "最高温 ℃",
  temp_low_c: "最低温 ℃",
  condition: "天气状况",
  precip_mm: "降水量 mm",
  device: "设备",
  now: "设备时间",
  home_screen_layout_seed: "主屏布局种子",
  atmosphere: "氛围",
  wallpaper: "壁纸",
  weather_sky_url: "天气天空",
  safari_brand_icons: "Safari 品牌图标",
  visits: "访问记录",
  apps: "应用",
  sender: "发送方",
  receiver: "接收方",
  sent_at: "发送时间",
  delivery: "发送状态",
  calls: "通话记录",
  type: "类型",
  date: "时间",
  number: "号码",
  voicemails: "语音信箱",
  initials: "缩写",
  color: "颜色",
  recorded_at: "录制时间",
  listened: "已听",
  photos: "照片",
  taken_at: "拍摄时间",
  location: "地点",
  album: "相册",
  favorite: "收藏",
  exif: "EXIF",
  scene: "场景",
  camera: "相机",
  lens: "镜头",
  iso: "ISO",
  image_url: "图片",
  screenshots: "截图",
  source: "来源",
  content_description: "内容说明",
  videos: "视频",
  albums: "相册列表",
  safari: "Safari",
  safari_bookmarks: "Safari 书签",
  favorites_count: "常用项目数量",
  tab_group_favorites_count: "标签页组个人收藏数量",
  context_path: "主角关联依据",
  context_anchor: "关联关键词",
  visited_at: "访问时间",
  url: "网址",
  is_bookmark: "书签",
  search_results: "搜索结果",
  display_url: "显示网址",
  snippet: "摘要",
  favicon_url: "站点图标",
  page: "页面内容",
  site_name: "站点名",
  section: "栏目",
  headline: "标题",
  standfirst: "导语",
  paragraphs: "段落",
  byline: "作者",
  published_at: "发布时间",
  reading_time_min: "阅读分钟",
  source_url: "来源链接",
  hero_image_urls: "头图",
  related: "相关阅读",
  footer_note: "页脚",
  blocks: "正文块",
  calendar: "日历",
  start_at: "开始",
  end_at: "结束",
  participants: "参与者",
  note: "备注",
  gmail: "邮件",
  direction: "方向",
  sender_email: "发件邮箱",
  recipient_email: "收件邮箱",
  received_at: "收到时间",
  subject: "主题",
  maps: "地图",
  siri_suggestions: "Siri 建议",
  poi: "兴趣点",
  duration_min: "停留分钟",
  clock: "时钟",
  alarms: "闹钟",
  time: "时间",
  enabled: "启用",
  repeat_days: "重复星期",
  sound: "铃声",
  whatsapp: "WhatsApp",
  group_id: "群聊 ID",
  group_name: "群聊名称",
  group_avatar_url: "群聊头像",
  group_members: "群成员",
  nickname: "群内昵称",
  notes: "备忘录",
  created_at: "创建时间",
  password: "应用密码",
  files: "文件",
  filename: "文件名",
  file_url: "PDF 文件",
  size_bytes: "体积",
  added_at: "添加时间",
  health: "健康",
  step_count: "步数",
  sleep_hours: "睡眠小时",
  heart_rate_avg: "平均心率",
  heart_rate_samples: "心率样本",
  heart_rate_summary_title: "心率摘要类型",
  heart_rate_summary: "心率摘要正文",
  bpm: "心率",
  instagram: "Instagram",
  instagram_messages: "Instagram 私信",
  owner_username: "机主账号",
  threads: "私信线程",
  participant_name: "对方名称",
  participant_username: "对方账号",
  participant_avatar_url: "对方头像",
  facebook: "Facebook",
  platform: "平台",
  author_handle: "账号",
  author_name: "作者名",
  caption: "文案",
  location_name: "地点名",
  posted_at: "发布时间",
  likes_count: "点赞数",
  comments: "评论",
  tinder: "Tinder",
  profiles: "资料",
  age: "年龄",
  distance: "距离",
  bio: "简介",
  verified: "已认证",
  matches: "匹配",
  profile: "资料名",
  message: "消息预览",
  unread: "未读",
  last_message_at: "最后消息时间",
  "voice-memos": "语音备忘录",
  audio_url: "音频",
  reminders: "提醒事项",
  items: "条目",
  done: "完成",
  airbnb: "Airbnb",
  map_url: "地图图",
  trips: "行程",
  check_in_at: "入住",
  check_out_at: "退房",
  place: "房源",
  host_name: "房东",
  pin: "坐标钉",
  paypal: "PayPal",
  balance: "余额",
  orders: "订单",
  tiktok: "TikTok",
  video_url: "视频文件",
  comments_count: "评论数",
  saves_count: "收藏数",
  shares_count: "分享数",
  uber: "Uber",
  carts: "购物车",
  started_at: "时间",
  items_count: "商品件数",
  deliver_to: "配送地址",
};

const APP_LABELS: Record<string, string> = {
  messages: "短信",
  messages_recently_deleted: "最近删除短信",
  phone: "电话",
  photos: "相册",
  safari: "Safari",
  safari_bookmarks: "Safari 书签",
  calendar: "日历",
  gmail: "邮件",
  maps: "地图",
  clock: "时钟",
  whatsapp: "WhatsApp",
  notes: "备忘录",
  files: "文件",
  health: "健康",
  instagram: "Instagram",
  instagram_messages: "Instagram 私信",
  facebook: "Facebook",
  tinder: "Tinder",
  "voice-memos": "语音备忘录",
  reminders: "提醒事项",
  airbnb: "Airbnb",
  paypal: "PayPal",
  tiktok: "TikTok",
  uber: "Uber",
};

export const WEATHER_CONDITION_LABELS: Record<string, string> = {
  clear: "晴",
  partly_cloudy: "少云",
  cloudy: "多云",
  rain: "雨",
};

export function labelForKey(key: string): string {
  if (KEY_LABELS[key]) return KEY_LABELS[key]!;
  if (APP_LABELS[key]) return APP_LABELS[key]!;
  return key.replace(/_/g, " ");
}

const GMAIL_DIRECTION_LABELS: Record<string, string> = {
  inbox: "收件箱",
  sent: "已发送",
  draft: "草稿",
};

const INSTAGRAM_SENDER_LABELS: Record<string, string> = {
  owner: "机主",
  participant: "对方",
};

export function labelForEnum(fieldKey: string, value: string): string {
  if (fieldKey === "condition") {
    return WEATHER_CONDITION_LABELS[value] ?? value;
  }
  if (fieldKey === "direction") {
    return GMAIL_DIRECTION_LABELS[value] ?? value;
  }
  if (fieldKey === "sender") {
    return INSTAGRAM_SENDER_LABELS[value] ?? value;
  }
  return value;
}

export function labelForApp(appKey: string): string {
  return APP_LABELS[appKey] ?? labelForKey(appKey);
}

export type EditorSection = {
  id: string;
  path: string;
  label: string;
  group?: string;
  count?: number;
};

function arrayLen(value: unknown): number | undefined {
  return Array.isArray(value) ? value.length : undefined;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function appBagCount(bag: unknown): number | undefined {
  if (Array.isArray(bag)) return bag.length;
  if (!isRecord(bag)) return undefined;
  let n = 0;
  let hasArray = false;
  for (const v of Object.values(bag)) {
    if (Array.isArray(v)) {
      hasArray = true;
      n += v.length;
    }
  }
  return hasArray ? n : undefined;
}

function appSection(key: string, bag: unknown): EditorSection {
  return {
    id: `app.${key}`,
    path: `device.apps.${key}`,
    label: labelForApp(key),
    group: "应用",
    count: appBagCount(bag),
  };
}

/** Build left-nav sections from schema catalog + current draft JSON. */
export function buildEditorSections(root: unknown): EditorSection[] {
  const sections: EditorSection[] = [
    { id: "package", path: "", label: "包信息", group: "基础" },
    {
      id: "meta",
      path: "meta",
      label: "元信息",
      group: "基础",
    },
    {
      id: "game.cast",
      path: "game.cast",
      label: "角色",
      group: "游戏",
    },
    {
      id: "game.guideSteps",
      path: "game.guideSteps",
      label: "引导步骤",
      group: "游戏",
      count: arrayLen(getNested(root, "game.guideSteps")),
    },
    {
      id: "game.puzzleSteps",
      path: "game.puzzleSteps",
      label: "谜题",
      group: "游戏",
      count: arrayLen(getNested(root, "game.puzzleSteps")),
    },
    {
      id: "game.closing",
      path: "game.closing",
      label: "收尾",
      group: "游戏",
    },
    {
      id: "canon.people",
      path: "canon.people",
      label: "人物",
      group: "设定",
      count: arrayLen(getNested(root, "canon.people")),
    },
    {
      id: "canon.relationships",
      path: "canon.relationships",
      label: "关系",
      group: "设定",
      count: arrayLen(getNested(root, "canon.relationships")),
    },
    {
      id: "canon.world",
      path: "canon.world",
      label: "世界",
      group: "设定",
    },
    {
      id: "device.shell",
      path: "device",
      label: "设备外壳",
      group: "设备",
    },
  ];

  const apps = getNested(root, "device.apps");
  const appsRecord = isRecord(apps) ? apps : {};
  const listed = new Set<string>();

  for (const key of DEVICE_APP_KEYS) {
    listed.add(key);
    sections.push(appSection(key, appsRecord[key]));
  }

  for (const key of Object.keys(appsRecord)) {
    if (listed.has(key)) continue;
    sections.push(appSection(key, appsRecord[key]));
  }

  return sections;
}

function getNested(root: unknown, path: string): unknown {
  if (!path) return root;
  let cur: unknown = root;
  for (const part of path.split(".")) {
    if (!isRecord(cur)) return undefined;
    cur = cur[part];
  }
  return cur;
}

/** Package-root fields only (exclude big nested objects). */
export const PACKAGE_ROOT_KEYS = [
  "id",
  "locale",
  "timezone",
  "phone_runtime_version",
] as const;

/** Device shell fields shown under 设备外壳 (not apps). */
export const DEVICE_SHELL_KEYS = [
  "now",
  "home_screen_layout_seed",
  "atmosphere",
] as const;
